const setCookie = (
  cname: string,
  cvalue: string,
  minutes: number,
  domain: string
): void => {
  const d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = `${cname}=${cvalue}; ${expires}; domain=${domain}`;
};

const removeCookie = (cname: string): void => {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const getCookie = (cname: string): string => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const cookie = (name: string) => ({
  get: () => new Promise<string>((resolve) => resolve(getCookie(name))),
  set: (value: string, domain: string) =>
    new Promise<void>((resolve) =>
      resolve(setCookie(name, value, Number.POSITIVE_INFINITY, domain))
    ),
  remove: () => new Promise<void>((resolve) => resolve(removeCookie(name))),
});
